var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedIn2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 0C18.6277 0 24 5.373 24 12C24 18.6271 18.6277 24 12 24C5.37217 24 0 18.627 0 12C0 5.37308 5.37225 0 12 0Z",
    fill: "#828282"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.76203 16.488H9.00905V8.99844H6.76203V16.488ZM15.5161 8.73902C14.4255 8.73902 13.4498 9.13726 12.7576 10.0163V8.97381H10.5023V16.488H12.7576V12.4245C12.7576 11.5658 13.5444 10.728 14.5298 10.728C15.5153 10.728 15.7584 11.5658 15.7584 12.4035V16.4873H18.0054V12.2363C18.0053 9.28349 16.6073 8.73902 15.5161 8.73902ZM7.87503 8.24999C8.49604 8.24999 9.00007 7.74596 9.00007 7.12495C9.00007 6.50394 8.49604 6 7.87503 6C7.25402 6 6.75 6.50402 6.75 7.12503C6.75 7.74604 7.25402 8.24999 7.87503 8.24999Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn2);
export default __webpack_public_path__ + "static/media/LinkedIn (2).9d92e4e4b54a11851fd895043e090ae2.svg";
export { ForwardRef as ReactComponent };